import { InitComponent } from "@/components/Reference"
import AtSuggestion from "@/components/Reference/At/AtSuggestion"
import AtSuggestionTask from "@/components/Reference/At/AtSuggestionTask"

import { ReferenceExtension } from "@/plugins/extensions/Reference"

export const ReferenceAt = ReferenceExtension.extend({
  name: "referenceAt"
}).configure({
  suggestion: AtSuggestion,
  pasteRules: "@\\w+\\s\\w+", // @FirstName LastName
  component: InitComponent
})

export const ReferenceAllUser = ReferenceExtension.extend({
  name: "referenceAllUser"
}).configure({
  suggestion: AtSuggestionTask,
  pasteRules: "@@\\w+\\s\\w+", // @FirstName LastName
  component: InitComponent
})
